import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import Input from "../../../../components/form/Input";
import Button from "../../../../components/form/Button";
import PublicPage from "../../components/PublicPage";
import { styles } from "../../index";
import { breadcrumbs } from "../../../../actions/appActions";
import { push } from "react-router-redux";
import { publicUrlHelp } from "../../CroUtils";
import H from "../../helpEnum";
import Help from "../../components/Help";

import { dataPageNoData } from "../../../../components/Grid/dataActions";
import { getDecodedUser } from "../../../../utils/login";
import InfoMessage from "../../components/InfoMessage";

const onSubmit = (auth, data) => (dispatch) => {
  const gridName = `officialsGrid_public_${getDecodedUser().sub || "notLogged"}`;
  dispatch(dataPageNoData(gridName, 0));

  dispatch(
    push(
      data.search
        ? `${publicUrlHelp(auth)}/funkcionari?q=${data.search}`
        : `${publicUrlHelp(auth)}/funkcionari`,
    ),
  );
};

const showAll = (auth, dispatch) => () => {
  const gridName = `officialsGrid_public_${getDecodedUser().sub || "notLogged"}`;
  dispatch(dataPageNoData(gridName, 0));

  dispatch(push(`${publicUrlHelp(auth)}/funkcionari`));
};

class Public extends Component {
  componentWillMount() {
    this.props.breadcrumbs([]);
  }

  render() {
    const { onSubmit, handleSubmit, dispatch, submitting, auth, location } = this.props;
    const message = location && location.query && location.query.message;
    return (
      <PublicPage title="Centrální registr oznámení">
        {message === "logout" && (
          <InfoMessage variant="success">
            Byl(a) jste úspěšně odhlášen(a).
          </InfoMessage>
        )}
        {/*<InfoMessage variant="error">*/}
        {/*  Informujeme vás, že dne 28. 4. 2026 od 18 hodin bude probíhat krátkodobá údržba systému. Omlouváme se za případné komplikace a děkujeme za pochopení.*/}
        {/*</InfoMessage>*/}
        <div className="publicHome">
          <div className="publicHome__card">
            <div className="publicHome__header">
              <div className="publicHome__title">Vyhledat osobu</div>
              <div className="publicHome__subtitle">
                Zadejte jméno, případně část jména a pokračujte vyhledáváním v
                registru.
              </div>
            </div>

            <form
              onSubmit={handleSubmit(onSubmit)}
              className="publicHome__form"
            >
              <div className="publicHome__searchRow">
                <div className="publicHome__searchField">
                  <Field
                    className="search"
                    name="search"
                    component={Input}
                    floatingLabelText="Hledat osobu"
                  />
                </div>
                <div className="publicHome__help">
                  <Help
                    helpEnum={H.PUBLIC_HOME_SEARCH.r}
                    tooltipPosition="bottom-right"
                  />
                </div>
              </div>

              <div className="publicHome__actions">
                <Button
                  type="submit"
                  style={styles.buttons}
                  label="Hledej"
                  disabled={submitting}
                />
                <Button
                  type="button"
                  style={styles.buttons}
                  label="Zobraz všechny"
                  disabled={submitting}
                  onClick={showAll(auth, dispatch)}
                />
              </div>
            </form>
          </div>
        </div>
      </PublicPage>
    );
  }
}

const Form = reduxForm({
  form: "publicHomeForm",
})(Public);

const mapDispatchToProps = (dispatch, { auth }) => ({
  ...bindActionCreators({ breadcrumbs }, dispatch),
  onSubmit: (data) => dispatch(onSubmit(auth, data)),
});

export default connect(null, mapDispatchToProps)(Form);
